import * as React from 'react';

import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { IncidentAndDamage } from '../../../../store/details/case/model';
import { StaticInformation } from '../../../custom/static-information';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './damage.module.css';
import { Currency } from '../../../../store/shared/types';

interface DamageProps {
  readonly damage: IncidentAndDamage;
  readonly header: string;
}

class Damage extends React.Component<DamageProps> {
  private localization: Ii18n;

  constructor(props: DamageProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
      <div className={styles.container}>
        <h2>{this.localization.get(this.props.header)}</h2>
        <div className={styles.static}>
          <div className={styles.staticContent}>
            <StaticInformation
              translation='details.case.damage'
              headerText='details.case.damage.building.header'
              headerSize='1.3em'
              information={{
                'lossDamageDescription': this.props.damage.buildingDamageLossDamageDescription,
                'lossEstimatedDamageAmount': this.props.damage.buildingDamageLossEstimatedDamageAmount ? new Currency(this.props.damage.buildingDamageLossEstimatedDamageAmount, '', '€') : undefined
              }} />
            <StaticInformation
              translation='details.case.damage'
              headerText='details.case.damage.content.header'
              headerSize='1.3em'
              information={{
                'lossDamageDescription': this.props.damage.contentDamageLossDamageDescription,
                'lossEstimatedDamageAmount': this.props.damage.contentDamageLossEstimatedDamageAmount ? new Currency(this.props.damage.contentDamageLossEstimatedDamageAmount, '', '€') : undefined
              }} />
            <StaticInformation
              translation='details.case.damage'
              headerText='details.case.damage.glass.header'
              headerSize='1.3em'
              information={{
                'lossDamageDescription': this.props.damage.glassDamageLossDamageDescription,
                'lossEstimatedDamageAmount': this.props.damage.glassDamageLossEstimatedDamageAmount ? new Currency(this.props.damage.glassDamageLossEstimatedDamageAmount, '', '€') : undefined
              }} />
            <StaticInformation
              translation='details.case.damage'
              headerText='details.case.damage.basement.header'
              headerSize='1.3em'
              information={{
                'lossDamageDescription': this.props.damage.basementDamageLossDamageDescription,
                'lossEstimatedDamageAmount': this.props.damage.basementDamageLossEstimatedDamageAmount ? new Currency(this.props.damage.basementDamageLossEstimatedDamageAmount, '', '€') : undefined
              }} />
            <StaticInformation
              translation='details.case.damage'
              headerText='details.case.damage.allRiskObject.header'
              headerSize='1.3em'
              information={{
                'lossDamageDescription': this.props.damage.allRiskObjectDamageLossDamageDescription,
                'lossEstimatedDamageAmount': this.props.damage.allRiskObjectDamageLossEstimatedDamageAmount ? new Currency(this.props.damage.allRiskObjectDamageLossEstimatedDamageAmount, '', '€') : undefined
              }} />
          </div>
        </div>
      </div>
    );
  }
}

export { Damage };
